var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",style:([_vm.estilo])},[_c('div',{staticClass:"columns"},[(_vm.temSlotTitulo)?_c('div',{staticClass:"column"},[_vm._t("titulo")],2):_vm._e(),_vm._v(" "),(_vm.temSlotMenu)?_c('div',{staticClass:"column has-text-right menu is-3"},[_vm._t("menu")],2):_vm._e()]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23426d32","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PortalBox.vue
// module id = J5J+
// module chunks = 0